import { array, addMethod } from 'yup';

const validateAtLeastOneProduct = () => {
  // eslint-disable-next-line func-names
  addMethod(array, 'atLeastOneProduct', function () {
    return this.test({
      name: 'atLeastOneProduct',
      message: 'At least one product must be selected',
      test: (values = []) => values.length > 0 && values.some(value => value.quantity !== 0),
    });
  });
};

export default validateAtLeastOneProduct;
